import React, { useMemo, useState, useCallback, useEffect } from 'react';
import SuccessIcon from 'Icons/Success.svg';
import CloseIcon from 'Icons/CustomSelectClose.svg';
import { AlertDTO, ProjectInfoDTO, ProjectNodeInfoDTO } from 'business/models/Models';
import { TreeService } from 'business/services/TreeService';

import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import NodeInfo from './NodeInfo';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import { showSnackBar } from 'utils/Global';
import useRMLite from 'CustomHooks/useRMLite';
const ProjectInfoPanel = ({
  selectedUser,
  selectedImageSchedule,
  usersList,
  imageScheduleList,
  createdDate,
  notes,
  projectId,
  treeNodeId,
}: any) => {
  const [projectPanelState, setProjectPanelState] = useState({
    isDataDisabled: true,
    isEditShow: 'block',
    oldSelectedOwner: selectedUser,
    oldSelectedImage: selectedImageSchedule,
    selectedOwner: selectedUser,
    selectedImage: selectedImageSchedule,
    selectedNotes: notes || '',
    oldNotes: notes || '',
  });
  const isRMLite = useRMLite();

  useEffect(() => {
    setProjectPanelState((prev) => ({
      ...prev,
      oldSelectedOwner: selectedUser,
      selectedOwner: selectedUser,
      oldSelectedImage: selectedImageSchedule,
      selectedImage: selectedImageSchedule,
      oldNotes: notes || '',
      selectedNotes: notes || '',
    }));
  }, [selectedUser, selectedImageSchedule, notes]);

  const onChangeUser = (event) => {
    setProjectPanelState({ ...projectPanelState, selectedOwner: event.target.value });
  };

  const onChangeNotes = (event) => {
    setProjectPanelState({ ...projectPanelState, selectedNotes: event.target.value });
  };

  const onChangeImageSchedule = (event) => {
    setProjectPanelState({ ...projectPanelState, selectedImage: event.target.value });
  };

  const returnCombo = useCallback(
    (list, selectedOption, disabled, placeholder, onChange, header) => {
      return (
        <div id='projectinfopanel-returncombo-wrapper' className="row" style={{ paddingTop: '5px', paddingInline: '2%' }}>
          <div id='projectinfopanel-returncombo-header' className="nodeInfo nodeLabel col-4">{header}</div>
          <div id='projectinfopanel-returncombo-col' className="nodeInfo col-6">
            <RMSelect
              options={list}
              selectedValue={selectedOption}
              disabled={disabled}
              className="padding5 disabled:bg-gray-100 disabled:opacity-30"
              onChange={onChange}
              placeholder={placeholder}
            />
          </div>
        </div>
      );
    },
    [],
  );

  const createUsersCombo = useMemo(() => {
    return returnCombo(
      usersList,
      projectPanelState.selectedOwner,
      projectPanelState.isDataDisabled,
      'Owner',
      onChangeUser,
      'Owner',
    );
  }, [usersList, projectPanelState]);

  const createImageScheduleCombo = useMemo(() => {
    return returnCombo(
      imageScheduleList,
      projectPanelState.selectedImage,
      projectPanelState.isDataDisabled,
      'Imaging Schedule',
      onChangeImageSchedule,
      'Imaging Schedule',
    );
  }, [imageScheduleList, projectPanelState]);

  const createNotes = useMemo(() => {
    return (
      <div id='projectinfopanel-createnotes-wrapper' className="row" style={{ paddingTop: '10px', paddingInline: '2%' }}>
        <div id='projectinfopanel-createnotes-label' className="nodeInfo nodeLabel col-4">Notes</div>
        <div id='projectinfopanel-createnotes-col' className="nodeInfo col-6">
          <textarea
            id='projectinfopanel-createnotes-textarea'
            onChange={onChangeNotes}
            disabled={projectPanelState.isDataDisabled}
            value={projectPanelState.selectedNotes}
          ></textarea>
        </div>
      </div>
    );
  }, [projectPanelState]);

  const createInfo = useMemo(() => {
    return (
      <NodeInfo labelName="Created" info={createdDate?.toLocaleDateString('en-US')} />
    );
  }, [createdDate]);

  const editData = () => {
    setProjectPanelState({
      ...projectPanelState,
      isDataDisabled: false,
      isEditShow: 'none',
    });
  };

  const closeEditData = () => {
    setProjectPanelState({
      ...projectPanelState,
      isDataDisabled: true,
      isEditShow: 'block',
      selectedOwner: projectPanelState.oldSelectedOwner,
      selectedImage: projectPanelState.oldSelectedImage,
      selectedNotes: projectPanelState.oldNotes,
    });
  };

  const saveData = async () => {
    const newNode: ProjectNodeInfoDTO = new ProjectNodeInfoDTO();
    newNode.node = new ProjectInfoDTO();
    newNode.treeNodeId = treeNodeId;
    newNode.node.id = projectId;
    newNode.node.defaultImagingScheduleId = projectPanelState.selectedImage;
    newNode.node.ownerUserId = projectPanelState.selectedOwner;
    newNode.node.notes = projectPanelState.selectedNotes;
    const res: AlertDTO = await new TreeService().UpdateProjectNodeData(newNode);
    if (res && res.alertMessage) {
      showSnackBar(res.alertMessage);
    }
    setProjectPanelState({
      ...projectPanelState,
      isDataDisabled: true,
      isEditShow: 'block',
      oldNotes: projectPanelState.selectedNotes,
      oldSelectedOwner: projectPanelState.selectedOwner,
      oldSelectedImage: projectPanelState.selectedImage,
    });
  };

  return (
    <div id='projectinfopanel-wrapper'>
      <div
        id='projectinfopanel-header'
        style={{ flex: '85%', paddingBlock: '10px', paddingInline: '2%' }}
        className="nodeInfo nodeLabel row"
      >
        <div id='projectinfopanel-title' className="col-6">Project Information</div>
        {!isRMLite ? (
          <>
            <div id="projectinfopanel-actions" className="col-5" style={{ textAlign: 'right' }}>
              <div id="projectinfopanel-edit-button-wrapper" style={{ display: projectPanelState.isEditShow }}>
                <RMCustomButton
                  Icon={
                    <RMSvgIcon  id="projectinfopanel-edit-svg-icon" name={'Edit'} fill="#00000" enableBackground={'false'} />
                  }
                  isDisabled={false}
                  showChevronIcon={false}
                  showBorder={false}
                  onClick={editData}
                />
              </div>
              <div
                id="projectinfopanel-save-cancel-wrapper"
                style={{
                  display: projectPanelState.isEditShow === 'block' ? 'none' : 'block',
                }}
              >
                <img
                  id="projectinfopanel-cancel-icon"
                  src={CloseIcon}
                  onClick={closeEditData}
                  alt=""
                  style={{ cursor: 'pointer', paddingLeft: '10px' }}
                />
                <img
                  id="projectinfopanel-save-icon"
                  src={SuccessIcon}
                  onClick={saveData}
                  alt=""
                  style={{ cursor: 'pointer', paddingLeft: '10px' }}
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
      {createInfo}
      {createUsersCombo}
      {createImageScheduleCombo}
      {createNotes}
    </div>
  );
};
export default ProjectInfoPanel;
